/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AllVasServiceRouteResponseDto } from '../model/allVasServiceRouteResponseDto';
import { CreateVasServiceRouteDto } from '../model/createVasServiceRouteDto';
import { VasServiceRouteResponseDto } from '../model/vasServiceRouteResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class VasServiceRouteService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRouteCreateVasServiceRoutePost(body?: CreateVasServiceRouteDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiVasServiceRouteCreateVasServiceRoutePost(body?: CreateVasServiceRouteDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiVasServiceRouteCreateVasServiceRoutePost(body?: CreateVasServiceRouteDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiVasServiceRouteCreateVasServiceRoutePost(body?: CreateVasServiceRouteDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/VasServiceRoute/CreateVasServiceRoute`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param routeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRouteDeleteServiceRouteRouteIdDelete(routeId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiVasServiceRouteDeleteServiceRouteRouteIdDelete(routeId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiVasServiceRouteDeleteServiceRouteRouteIdDelete(routeId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiVasServiceRouteDeleteServiceRouteRouteIdDelete(routeId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (routeId === null || routeId === undefined) {
            throw new Error('Required parameter routeId was null or undefined when calling apiVasServiceRouteDeleteServiceRouteRouteIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/VasServiceRoute/DeleteServiceRoute/${encodeURIComponent(String(routeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRouteGetAllVasServiceRouteGet(observe?: 'body', reportProgress?: boolean): Observable<Array<AllVasServiceRouteResponseDto>>;
    public apiVasServiceRouteGetAllVasServiceRouteGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AllVasServiceRouteResponseDto>>>;
    public apiVasServiceRouteGetAllVasServiceRouteGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AllVasServiceRouteResponseDto>>>;
    public apiVasServiceRouteGetAllVasServiceRouteGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AllVasServiceRouteResponseDto>>('get',`${this.basePath}/api/VasServiceRoute/GetAllVasServiceRoute`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param routeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRouteGetServiceRouteByRouteIdRouteIdGet(routeId: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceRouteResponseDto>;
    public apiVasServiceRouteGetServiceRouteByRouteIdRouteIdGet(routeId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceRouteResponseDto>>;
    public apiVasServiceRouteGetServiceRouteByRouteIdRouteIdGet(routeId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceRouteResponseDto>>;
    public apiVasServiceRouteGetServiceRouteByRouteIdRouteIdGet(routeId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (routeId === null || routeId === undefined) {
            throw new Error('Required parameter routeId was null or undefined when calling apiVasServiceRouteGetServiceRouteByRouteIdRouteIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceRouteResponseDto>('get',`${this.basePath}/api/VasServiceRoute/GetServiceRouteByRouteId/${encodeURIComponent(String(routeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasServiceId 
     * @param routeId 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRouteGetServiceRouteByServiceIdAndRouteIdVasServiceIdRouteIdGet(vasServiceId: string, routeId: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<VasServiceRouteResponseDto>;
    public apiVasServiceRouteGetServiceRouteByServiceIdAndRouteIdVasServiceIdRouteIdGet(vasServiceId: string, routeId: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceRouteResponseDto>>;
    public apiVasServiceRouteGetServiceRouteByServiceIdAndRouteIdVasServiceIdRouteIdGet(vasServiceId: string, routeId: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceRouteResponseDto>>;
    public apiVasServiceRouteGetServiceRouteByServiceIdAndRouteIdVasServiceIdRouteIdGet(vasServiceId: string, routeId: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (vasServiceId === null || vasServiceId === undefined) {
            throw new Error('Required parameter vasServiceId was null or undefined when calling apiVasServiceRouteGetServiceRouteByServiceIdAndRouteIdVasServiceIdRouteIdGet.');
        }

        if (routeId === null || routeId === undefined) {
            throw new Error('Required parameter routeId was null or undefined when calling apiVasServiceRouteGetServiceRouteByServiceIdAndRouteIdVasServiceIdRouteIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceRouteResponseDto>('get',`${this.basePath}/api/VasServiceRoute/GetServiceRouteByServiceIdAndRouteId/${encodeURIComponent(String(vasServiceId))}/${encodeURIComponent(String(routeId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceRouteGetServiceRouteByServiceIdServiceIdGet(serviceId: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceRouteResponseDto>;
    public apiVasServiceRouteGetServiceRouteByServiceIdServiceIdGet(serviceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceRouteResponseDto>>;
    public apiVasServiceRouteGetServiceRouteByServiceIdServiceIdGet(serviceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceRouteResponseDto>>;
    public apiVasServiceRouteGetServiceRouteByServiceIdServiceIdGet(serviceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceId === null || serviceId === undefined) {
            throw new Error('Required parameter serviceId was null or undefined when calling apiVasServiceRouteGetServiceRouteByServiceIdServiceIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceRouteResponseDto>('get',`${this.basePath}/api/VasServiceRoute/GetServiceRouteByServiceId/${encodeURIComponent(String(serviceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
